const LOGO_URL = "https://customer-assets.emergentagent.com/job_opus-library/artifacts/l9b1gsxx_Opus2.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t mt-0"
      style={{ background: "var(--opus-sage)", borderColor: "var(--opus-sage-dark)", color: "rgba(255,255,255,0.86)" }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-14 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <img src={LOGO_URL} alt="Opus" className="w-14 mb-4 opacity-95" style={{ filter: "brightness(0) invert(1)" }} />
          <p className="font-display text-2xl tracking-[0.18em] uppercase" style={{ color: "#fff" }}>Opus</p>
          <p className="font-body text-sm mt-3 max-w-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.72)" }}>
            Practical business operations support for growing teams.
          </p>
        </div>
        <div className="text-sm font-body">
          <p className="uppercase tracking-[0.3em] text-[0.7rem] mb-4" style={{ color: "rgba(255,255,255,0.55)" }}>Resources</p>
          <ul className="space-y-2.5">
            <li><a href="/" className="hover:underline">All Downloads</a></li>
            <li><a href="/recover" className="hover:underline">Recover a Purchase</a></li>
          </ul>
        </div>
        <div className="text-sm font-body">
          <p className="uppercase tracking-[0.3em] text-[0.7rem] mb-4" style={{ color: "rgba(255,255,255,0.55)" }}>Connect</p>
          <ul className="space-y-2.5">
            <li><a href="https://www.opusbusinessoperations.com/" target="_blank" rel="noreferrer" className="hover:underline">Main site</a></li>
            <li><a href="https://www.opusbusinessoperations.com/contact" target="_blank" rel="noreferrer" className="hover:underline">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "rgba(255,255,255,0.10)" }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-5 text-[0.7rem] tracking-[0.2em] uppercase" style={{ color: "rgba(255,255,255,0.55)" }}>
          © {new Date().getFullYear()} Opus Business Operations. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
